import { useState } from 'react';
import { cn } from '../lib/utils';
import { UrlTab } from '../components/UrlTab';
import { TextTab } from '../components/TextTab';

export function CreateRecord() {
  const [activeTab, setActiveTab] = useState<'url' | 'text' | 'prompt'>('url');

  return (
    <div className="max-w-3xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Create New Record</h1>

      <div className="bg-[#282828] rounded-lg p-6">
        <div className="flex gap-4 mb-6">
          <button
            onClick={() => setActiveTab('url')}
            className={cn(
              'px-4 py-2 rounded-full transition-colors',
              activeTab === 'url'
                ? 'bg-[#1DB954] text-white'
                : 'text-gray-400 hover:text-white'
            )}
          >
            Create by URL
          </button>
          <button
            onClick={() => setActiveTab('text')}
            className={cn(
              'px-4 py-2 rounded-full transition-colors',
              activeTab === 'text'
                ? 'bg-[#1DB954] text-white'
                : 'text-gray-400 hover:text-white'
            )}
          >
            Create by Text
          </button>
        </div>

        {activeTab === 'url' && <UrlTab />}
        {activeTab === 'text' && <TextTab />}
      </div>
    </div>
  );
}